import React, { ReactElement } from "react";

import { RecordTypeBadge } from "../../../../common/components/RecordTypeBadge";
import { RecordType } from "../../../../common/types/RecordType";

export const renderFileRecordType = (item?: { recordType?: RecordType }): ReactElement | null => {
    const { recordType } = item || {};

    return <RecordTypeBadge value={recordType} />;
};
